import { OTPDialogTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const OTPDialogTrackingSchema: Record<OTPDialogTrackingPoint, string> = {
  [OTPDialogTrackingPoint.OTPDialogPopupImpression]:
    '88721d66-9397-438a-b057-bfbb379b8e0c',
  [OTPDialogTrackingPoint.OTPDialogPopupConfirmButtonClick]:
    'c8df13dd-82cb-4caa-9129-d04cfb3d8391',
};

export const getOTPDialogPageTypeAndSchema = (
  trackingPoint: OTPDialogTrackingPoint
) => {
  return {
    page_type: PageType.OTPDialogPopup,
    schema: OTPDialogTrackingSchema[trackingPoint],
  };
};
